import React from 'react';

interface ChangeRoleConfirmationModalProps {
  memberName: string;
  oldRole: string;
  newRole: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ChangeRoleConfirmationModal: React.FC<
  ChangeRoleConfirmationModalProps
> = ({ memberName, oldRole, newRole, onClose, onConfirm }) => {
  // Closes the modal without applying changes
  const handleCancel = () => {
    onClose();
  };

  // Confirms the role change and triggers the provided callback
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className='fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50'>
      <div className='bg-white w-full max-w-lg rounded-lg shadow-lg p-6 relative'>
        {/* Header */}
        <div className='flex justify-between items-center mb-2'>
          <h2 className='text-[24px] font-semibold text-[#3F5265]'>
            Change Role
          </h2>
          <button
            onClick={handleCancel}
            className='text-gray-400 hover:text-gray-600 text-2xl font-light'
          >
            ×
          </button>
        </div>

        {/* Subtitle */}
        <p className='text-[16px] text-[#657584] mb-4'>
          Changing roles will immediately update this member’s permissions.
        </p>

        {/* Info Box */}
        <div className='bg-[#E0F8FB] rounded-md p-4 text-[14px] text-[#00899E] leading-relaxed'>
          <p>
            You’re changing <span className='font-semibold'>{memberName}</span>
            ’s role from <span className='font-semibold'>
              {oldRole}
            </span> to <span className='font-semibold'>{newRole}</span>.
          </p>
          <p className='mt-2'>
            This change will also update their access permissions based on the
            new role.
          </p>
          <p className='mt-2'>Do you want to continue?</p>
        </div>

        {/* Actions */}
        <div className='flex justify-end gap-3 mt-10'>
          <button
            onClick={handleCancel}
            className='px-4 py-2 border rounded-md text-gray-600 border-gray-300 hover:bg-gray-50'
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className='px-5 py-2 bg-[#FF5A47] text-white rounded-md hover:bg-[#e24a39]'
          >
            Change Role
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeRoleConfirmationModal;
